import React from 'react';
import IsHeMineLogo from "../Assets/ishemine-header-logo.png"

const Logo = () => {
  return (
    <img src={IsHeMineLogo} alt="Logo" className="h-8 cursor-pointer" />
  );
};

export default Logo;